<template>
    <div>
        <b-spinner
            variant="primary"
            v-if="isSpinnerUp"
            large
            class="pageLoadSpinners loaderDetail"
        />
        <div v-show="!isSpinnerUp">
            <b-tab title="Upcoming Session(s)" @click="onUpComingSessionLearner">
                <div v-if="!isSpinnerUp">
                    <div class="card user_filter" v-if="isLearner">
                        <h2>Filter</h2>
                        <b-form @submit.prevent>
                            <b-row>
                                <b-col xl="3" lg="4" md="5">
                                    <label>Date</label>
                                    <flat-pickr
                                        v-model="dateNtimUpcomig"
                                        class="form-control datetime_picker"
                                        :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', minDate: 'today'}"
                                    />
                                </b-col>
                            </b-row>
                        </b-form>
                    </div>
                </div>
                <div class="card user_table session_table upcoming" v-if="!isSpinnerUp">
                    <div class="custom-search d-flex justify-content-end">
                        <b-form-group>
                            <div class="d-flex align-items-center">
                                <b-form-input
                                    v-model="sessionsearchTerm"
                                    placeholder="Search..."
                                    type="text"
                                    class="d-inline-block"
                                />
                                </div>
                        </b-form-group>
                    </div>
                    <vue-good-table
                        :columns="canceledsessioncolumnsdetail"
                        :rows="filterRows"
                        @on-cell-click="onCellClick"
                        :rtl="direction"
                        class="cursor_pointer"
                        :search-options="{
                            enabled: true,
                            externalQuery: sessionsearchTerm,
                        }"
                        :select-options="{
                            enabled: true,
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                            disableSelectInfo: true, // disable the select info panel on top
                        }"
                        :pagination-options="{
                            enabled: true,
                            perPage: pageLength,
                        }"
                        >
                        <template slot="table-row" slot-scope="props">
                        
                            <span
                                v-if="props.column.field === 'bookingid'"
                                class="text-nowrap userid"
                                >
                              {{ props.row.bookingid }}
                            </span>
                            <span
                                v-else-if="props.column.field === 'learnername'"
                                class="text-nowrap"
                                >
                                <b-avatar :src="props.row.avatar" class="user_img" />
                                <span class="userid" @click="getDataAgain()">
                                    <router-link 
                                    :to="`/user-management/users/${props.row.bookinglearnerId}`"
                                    >{{props.row.learnername.firstName}} {{props.row.learnername.lastName}}</router-link>
                                </span>
                            </span>

                            <span
                                v-else-if="props.column.field === 'bookingcredits'"
                                class="text-nowrap"
                                >
                                <span v-if="props.row.bookingcredits !== 0">
                                    {{ props.row.bookingcredits }} Credits
                                </span>
                                <span v-else style="color: red">
                                    Trial Booking
                                </span>
                            </span>
                            <span
                                v-else-if="props.column.field === 'action'"
                                class="action_field action_field1515"
                                >
                                <span>
                                    <b-dropdown
                                        variant="link"
                                        toggle-class="text-decoration-none"
                                        :disabled="userStatus == 4"
                                        no-caret
                                        >
                                        <template v-slot:button-content>
                                            <feather-icon
                                            icon="MoreVerticalIcon"
                                            size="16"
                                            class="text-body align-middle mr-25"
                                            />
                                        </template>
                                        <b-dropdown-item>
                                            <span v-b-modal.modal-cancel-booking @click="selctedSessionId = props.row.Id">
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                        d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389959 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0ZM9 16.3636C7.54361 16.3636 6.11993 15.9318 4.90899 15.1226C3.69804 14.3135 2.75423 13.1635 2.19689 11.8179C1.63955 10.4724 1.49373 8.99183 1.77786 7.56343C2.06199 6.13502 2.7633 4.82295 3.79313 3.79312C4.82295 2.7633 6.13502 2.06198 7.56343 1.77785C8.99183 1.49373 10.4724 1.63955 11.8179 2.19689C13.1635 2.75422 14.3135 3.69804 15.1226 4.90898C15.9318 6.11993 16.3636 7.54361 16.3636 9C16.3636 10.953 15.5878 12.8259 14.2069 14.2069C12.8259 15.5878 10.953 16.3636 9 16.3636ZM12.0355 7.12636L10.1536 9L12.0355 10.8736C12.1121 10.9497 12.173 11.0402 12.2145 11.1399C12.2561 11.2396 12.2775 11.3465 12.2775 11.4545C12.2775 11.5626 12.2561 11.6695 12.2145 11.7692C12.173 11.8689 12.1121 11.9594 12.0355 12.0355C11.9594 12.1121 11.8689 12.173 11.7692 12.2145C11.6695 12.2561 11.5626 12.2775 11.4545 12.2775C11.3465 12.2775 11.2396 12.2561 11.1399 12.2145C11.0402 12.173 10.9497 12.1121 10.8736 12.0355L9 10.1536L7.12637 12.0355C7.05031 12.1121 6.95981 12.173 6.86011 12.2145C6.76041 12.2561 6.65347 12.2775 6.54546 12.2775C6.43745 12.2775 6.33051 12.2561 6.2308 12.2145C6.1311 12.173 6.04061 12.1121 5.96455 12.0355C5.88786 11.9594 5.82699 11.8689 5.78546 11.7692C5.74392 11.6695 5.72253 11.5626 5.72253 11.4545C5.72253 11.3465 5.74392 11.2396 5.78546 11.1399C5.82699 11.0402 5.88786 10.9497 5.96455 10.8736L7.84637 9L5.96455 7.12636C5.81048 6.9723 5.72393 6.76334 5.72393 6.54545C5.72393 6.32757 5.81048 6.11861 5.96455 5.96454C6.11861 5.81048 6.32757 5.72392 6.54546 5.72392C6.76334 5.72392 6.9723 5.81048 7.12637 5.96454L9 7.84636L10.8736 5.96454C11.0277 5.81048 11.2367 5.72392 11.4545 5.72392C11.6724 5.72392 11.8814 5.81048 12.0355 5.96454C12.1895 6.11861 12.2761 6.32757 12.2761 6.54545C12.2761 6.76334 12.1895 6.9723 12.0355 7.12636Z"
                                                        fill="#606060"
                                                        />
                                                </svg>
                                                Cancel Booking
                                            </span>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </span>
                            </span>
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                            <div class="d-flex justify-content-between flex-wrap">
                            <div class="d-flex align-items-center mb-0 mt-1">
                                <span class="text-nowrap">
                                <span v-if="props.total === 0"> Showing 0 </span>
                                <span v-else> Showing {{(pageLength*(currentPage-1)+1)}} </span> 
                                to
                                <span v-if="props.total > pageLength*currentPage">{{(pageLength*currentPage)}} of {{ props.total }} entries</span>
                                <span v-else>{{props.total}} of {{ props.total }} entries</span>
                                </span>

                                    <div class="d-flex align-items-center mb-1 mt-0 showentry">
                                    <span>Show</span>
                                    <b-form-select
                                        v-model="pageLength"
                                        :options="['10', '20', '30', '40', '50']"
                                        class="mx-1"
                                        @input="
                                        (value) => props.perPageChanged({ currentPerPage: value })
                                        "
                                    />
                                    <span>entries</span>
                                    </div>
                            </div>
                            <div>
                                <b-pagination
                                :value="1"
                                :total-rows="props.total"
                                :current-page="currentPage"
                                :per-page="pageLength"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="mt-1 mb-0"
                                @input="
                                    (value) => {
                                    props.pageChanged({ currentPage: value });
                                    currentPage = value
                                    }
                                "
                                >
                                <template #prev-text>
                                    <feather-icon icon="ChevronLeftIcon" size="18" />
                                </template>
                                <template #next-text>
                                    <feather-icon icon="ChevronRightIcon" size="18" />
                                </template>
                                </b-pagination>
                            </div>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </b-tab>
        </div>
        <b-modal
        id="modal-cancel-booking"
        ref="my-modal"
        title="Cancellation Reason"
        ok-title="Booking Cancel"
        data-class="addcredit_popup"
        data-value-class="addcredit_popup"
        centered
        cancel-variant="outline-secondary"
        @show="cancelbookingresetModal"
        @hidden="cancelbookingresetModal"
        @ok="cancelbookinghandleOk"
        :ok-disabled="isSpinnerUp"
        :cancel-disabled="isSpinnerUp"
        >
        <validation-observer ref="formCancel">
        <b-form ref="form" @submit.stop.prevent="cancelbookinghandleSubmit">
            <b-form-group class="radioselected" label="Radio Button" label-for="usertype">
                <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Not interested in this Session"
                >
                Not interested in this Session
                </b-form-radio>
                <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Not available"
                >
                Not available
                </b-form-radio>
                <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Medical Emergency"
                >
                Medical Emergency
                </b-form-radio>
                <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Family situation"
                >
                Family situation
                </b-form-radio>
                <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Other"
                >
                Other
                </b-form-radio>
            </b-form-group>
            <validation-provider
            #default="{ errors }"
            name="reason for cancellation"
            rules="required|max:300"
            v-if="RadioSelected === 'Other'"
            >
            <b-form-group
                :state="nameState"
                label="Reason for Cancellation"
                label-for="name-input"
                invalid-feedback="Reason for Cancellation is required"
                v-if="RadioSelected === 'Other'"
            >
                <b-form-textarea
                id="name-input"
                v-model="cancelReasonName"
                :state="nameState"
                placeholder="Enter Reason for Cancellation"
                required
                maxlength= "300"
                />
                <small class="text-danger" style="display:block;">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>
        </b-form>
        </validation-observer>
        </b-modal>
    </div>
</template>
<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BTabs,
  BTab,
  BCardText,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BForm,
  BButton,
  BSpinner,
  BFormTextarea,
  BFormRadio
} from "bootstrap-vue";
import firebase from "@/utils/firebaseInit"
import * as insertFirebase from "@/utils/FirebaseQueries/insertQueries/insertQueries.js";
import * as getFirebase from "@/utils/FirebaseQueries/getQueries/getQueries";
import * as updateFirebase from "@/utils/FirebaseQueries/updateQueries/updateQueries";
import { dbCollections } from "@/utils/firebaseCollection.js";
import { VueGoodTable } from "vue-good-table";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import axios from "axios";
const db = firebase.firestore();
import { adminBookingNotification } from '../../../SessionsManagement/PendingSession(s)/service.js';
import { onBookingCancelUpdateSlot } from '@/utils/globalFunction/updateSlotWhenCancelBookingService.js'
import {errorEmail} from "@/utils/apiRequests.js"
const currentFileName = "src/views/Users/User/UserDetailTabs/Upcoming_Session_Tutor.vue"
export default {
    name: "UpcomingSesionTutor",
    directives: {
        Ripple,
    },
    components: {
        VueGoodTable,
        BCard,
        BImg,
        BRow,
        BCol,
        BDropdown,
        BDropdownItem,
        BCardText,
        BTabs,
        BTab,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BForm,
        BButton,
        flatPickr,
        BSpinner,
        BFormTextarea,
        BFormRadio,
        ValidationProvider,
        ValidationObserver,
    },
    props : {
        userDetail:Array,
        isLearner:Boolean,
        getDataAgain: Function,
        userStatus: Number,
    },
    data() {
        return {
            sessionsrows: [],
            direction: false,
            pageLength: 10,
            currentPage: 1,
            canceledsessionsearchTerm: "",
            sessionsearchTerm:"",
            sessioncolumns:[],
            selctedSessionId: '',
            canceledsessioncolumnsdetail: [
                {
                    label: "Booking ID",
                    field: "bookingid",
                },
                {
                    label: "Session Booking Date & Time",
                    field: "sessionDateTime",
                },
                {
                    label: "Session(s) Title",
                    field: "sessiontitle",
                },
                {
                    label: "Learner Name",
                    field: "learnername",
                },
                {
                    label: "Booking Credits",
                    field: "bookingcredits",
                },
                {
                    label: "Action",
                    field: "action",
                },
            ],
            cancelrows:[],
            dateNtimUpcomig: moment(new Date()).format("YYYY-MM-DD HH:mm"),
            isSpinnerUp: false,
            RadioSelected: "Not interested in this Session",
            cancelReasonName: '',
            bookingIdForSession:'',
            usedCredit: 0,
            learnerIdOfTheSession:''
        }
    },
    computed: {
        filterRows() {
            var self = this;
            var listA = self.cancelrows;
            if (self.dateNtimUpcomig === moment(new Date()).format("YYYY-MM-DD HH:mm")) {
                return listA;
            }
            if (self.dateNtimUpcomig != new Date()) {
                listA = listA.filter((data) => {
                return data.startTime > self.dateNtimUpcomig
                });
            }
            return listA;
        }
    },

    watch:{
        userDetail(newV , preV){
            if(newV !== preV && newV !== null){
                this.upcomingDetail();
            }
        },
        isLearner(newV , preV){
            if(newV !== preV){
                this.upcomingDetail();
            }
        }
    },

    methods: {
        onCellClick(data) {
            if (data.column.field==="learnername") {
                this.$router.push({name: 'user-details', params: { id: data.row.bookinglearnerId }})
            } else if(data.column.field==="action"){
                return;
            } 
            else {
                this.$router.push({name: 'upcoming-session-details', params: { id: data.row.Id}})
            }
        },
        sessionTimeCalculate(startTime , endTime) {
            if (moment(startTime.seconds*1000).format("DD-MM-YYYY") == moment(endTime.seconds*1000).format("DD-MM-YYYY")) {
                return `${moment(startTime.seconds*1000).format("DD-MM-YYYY, hh:mm A")} to ${moment(endTime.seconds*1000).format("hh:mm A")}`
            } else {
                return `${moment(startTime.seconds*1000).format("DD-MM-YYYY, hh:mm A")} to ${moment(endTime.seconds*1000).format("DD-MM-YYYY, hh:mm A")}`
            }
        },
        upcomingDetail(){
            var self = this;
            self.isSpinnerUp = true;
            self.cancelrows = [];
            if(this.userDetail !== undefined &&this.userDetail.includes('learner') && this.userDetail.includes('tutor')){
                if(!this.isLearner){
                    try {
                        getFirebase.simpleGetDataWithSpecificThreeWhereCondition(
                            dbCollections.BOOKING,
                            "learnerId","==",this.$route.params.id,
                            "status","==", 1,
                            "startTime", ">", new Date(),
                            (res) => {
                                if(res.length == 0 ){
                                    self.isSpinnerUp = false;
                                    return;
                                }
                                res.forEach((upcomingDataDetailLearner) => {
                                    this.count = +1;
                                    var cancel = {
                                        ...upcomingDataDetailLearner,
                                        bookingid: upcomingDataDetailLearner.bookingId,
                                        Id: upcomingDataDetailLearner.id,
                                        learnername: upcomingDataDetailLearner.tutorDetails,
                                        sessiontitle: upcomingDataDetailLearner.sessionDetails.name,
                                        sessionDateTime: this.sessionTimeCalculate(upcomingDataDetailLearner.startTime, upcomingDataDetailLearner.endTime),
                                        bookingcredits:upcomingDataDetailLearner.usedCredits,
                                        bookinglearnerId:upcomingDataDetailLearner.tutor,
                                        startTime:moment(upcomingDataDetailLearner.startTime.seconds*1000).format("YYYY-MM-DD HH:mm"),
                                        avatar: upcomingDataDetailLearner.tutorDetails.profilePicture,
                                        isTrial : upcomingDataDetailLearner.isTrial ? upcomingDataDetailLearner.isTrial : null,
                                    };
                                    self.cancelrows.push(cancel);
                                    if(res.length == this.cancelrows.length){
                                        self.isSpinnerUp = false;
                                    }
                                });
                            }
                        );
                        this.canceledsessioncolumnsdetail[3].label = "Tutor Name"
                    } catch (error) {
                        console.error("error", error);
                        self.isSpinnerUp = false;
                        errorEmail({
                        projectName : process.env.VUE_APP_PROJECTNAME,
                        environment : process.env.NODE_ENV,
                        fileName : currentFileName,
                        hookName : "upcomingDetail",
                        errorMessage : error.message
                        },(res)=>{
                        if(res.error){
                            console.error(res.error)
                        }
                        })
                    }
                }
                else{
                    try {
                        getFirebase.simpleGetDataWithSpecificThreeWhereCondition(
                            dbCollections.BOOKING,
                            "tutor","==",this.$route.params.id,
                            "status","==", 1,
                            "startTime", ">", new Date(),
                            (res) => {
                                if(res.length === 0 ){
                                    self.isSpinnerUp = false;
                                    return;
                                }
                                res.forEach((upcomingDataDetailLearner) => {
                                    this.count = +1;
                                    var cancel = {
                                        ...upcomingDataDetailLearner,
                                        bookingid: upcomingDataDetailLearner.bookingId,
                                        Id: upcomingDataDetailLearner.id,
                                        learnername: upcomingDataDetailLearner.learnerDetails,
                                        sessiontitle: upcomingDataDetailLearner.sessionDetails.name,
                                        sessionDateTime: this.sessionTimeCalculate(upcomingDataDetailLearner.startTime, upcomingDataDetailLearner.endTime),
                                        bookingcredits:upcomingDataDetailLearner.usedCredits,
                                        bookinglearnerId:upcomingDataDetailLearner.learnerId,
                                        startTime:moment(upcomingDataDetailLearner.startTime.seconds*1000).format("YYYY-MM-DD HH:mm"),
                                        avatar: upcomingDataDetailLearner.learnerDetails.profileImage,
                                        isTrial : upcomingDataDetailLearner.isTrial ? upcomingDataDetailLearner.isTrial : null,
                                    };
                                    self.cancelrows.push(cancel);
                                    if(res.length == this.cancelrows.length){
                                        self.isSpinnerUp = false;
                                    }
                                });
                            }
                        );
                        this.canceledsessioncolumnsdetail[3].label = "Learner Name"
                    } catch (error) {
                        console.error("error", error);
                        errorEmail({
                        projectName : process.env.VUE_APP_PROJECTNAME,
                        environment : process.env.NODE_ENV,
                        fileName : currentFileName,
                        hookName : "upcomingDetail",
                        errorMessage : error.message
                        },(res)=>{
                        if(res.error){
                            console.error(res.error)
                        }
                        })
                    }
                }
            }
            else if (this.userDetail!== undefined &&this.userDetail.includes('learner')) {
                try {
                    getFirebase.simpleGetDataWithSpecificThreeWhereCondition(
                        dbCollections.BOOKING,
                        "learnerId","==",this.$route.params.id,
                        "status","==", 1,
                        "startTime", ">", new Date(),
                        (res) => {
                            if(res.length === 0 ){
                                self.isSpinnerUp = false;
                                return;
                            }
                            res.forEach((upcomingDataDetailLearner) => {
                                var cancel = {
                                    ...upcomingDataDetailLearner,
                                    bookingid: upcomingDataDetailLearner.bookingId,
                                    Id: upcomingDataDetailLearner.id,
                                    learnername: upcomingDataDetailLearner.tutorDetails,
                                    sessiontitle: upcomingDataDetailLearner.sessionDetails.name,
                                    sessionDateTime: this.sessionTimeCalculate(upcomingDataDetailLearner.startTime, upcomingDataDetailLearner.endTime),
                                    bookingcredits:upcomingDataDetailLearner.usedCredits,
                                    bookinglearnerId:upcomingDataDetailLearner.tutor,
                                    startTime:moment(upcomingDataDetailLearner.startTime.seconds*1000).format("YYYY-MM-DD HH:mm"),
                                    avatar: upcomingDataDetailLearner.tutorDetails.profilePicture,
                                    isTrial : upcomingDataDetailLearner.isTrial ? upcomingDataDetailLearner.isTrial : null,
                                };
                                self.cancelrows.push(cancel);
                                if(res.length == this.cancelrows.length){
                                        self.isSpinnerUp = false;
                                }
                            });
                        }
                    );
                    this.canceledsessioncolumnsdetail[3].label = "Tutor Name"
                } catch (error) {
                    console.error("error", error);
                    errorEmail({
                        projectName : process.env.VUE_APP_PROJECTNAME,
                        environment : process.env.NODE_ENV,
                        fileName : currentFileName,
                        hookName : "upcomingDetail",
                        errorMessage : error.message
                        },(res)=>{
                        if(res.error){
                            console.error(res.error)
                        }
                        })
                }
            }
            else if (this.userDetail!== undefined &&this.userDetail.includes('tutor')) {
                try {
                    getFirebase.simpleGetDataWithSpecificThreeWhereCondition(
                        dbCollections.BOOKING,
                        "tutor","==",this.$route.params.id,
                        "status","==", 1,
                        "startTime", ">", new Date(),
                        (res) => {
                            if(res.length === 0 ){
                                self.isSpinnerUp = false;
                                return;
                            }
                            res.forEach((upcomingDataDetailLearner) => {
                                var cancel = {
                                    ...upcomingDataDetailLearner,
                                    bookingid: upcomingDataDetailLearner.bookingId,
                                    Id: upcomingDataDetailLearner.id,
                                    learnername: upcomingDataDetailLearner.learnerDetails,
                                    sessiontitle: upcomingDataDetailLearner.sessionDetails.name,
                                    sessionDateTime: this.sessionTimeCalculate(upcomingDataDetailLearner.startTime, upcomingDataDetailLearner.endTime),
                                    bookingcredits:upcomingDataDetailLearner.usedCredits,
                                    bookinglearnerId:upcomingDataDetailLearner.learnerId,
                                    startTime:moment(upcomingDataDetailLearner.startTime.seconds*1000).format("YYYY-MM-DD HH:mm"),
                                    avatar: upcomingDataDetailLearner.learnerDetails.profileImage,
                                    isTrial : upcomingDataDetailLearner.isTrial ? upcomingDataDetailLearner.isTrial : null,
                                }
                                self.cancelrows.push(cancel);
                                if(res.length == this.cancelrows.length){
                                    self.isSpinnerUp = false;
                                }
                            });
                        }
                    );
                    this.canceledsessioncolumnsdetail[3].label = "Learner Name"
                } catch (error) {
                        console.error("error", error);
                        errorEmail({
                        projectName : process.env.VUE_APP_PROJECTNAME,
                        environment : process.env.NODE_ENV,
                        fileName : currentFileName,
                        hookName : "upcomingDetail",
                        errorMessage : error.message
                        },(res)=>{
                        if(res.error){
                            console.error(res.error)
                        }
                        })
                }
            }
        },

        cancelbookingresetModal() {
            this.cancelReasonName = "";
            this.nameState = null;
        },

        cancelbookinghandleOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.cancelbookinghandleSubmit(bvModalEvt);   
        },
        cancelbookinghandleSubmit() {
            this.$refs.formCancel.validate().then((valid)=>{
                if(valid){
                    this.isSpinnerUp = true;
                    let Index = this.cancelrows.findIndex((values) => {
                        return values.Id == this.selctedSessionId;
                    });
                    this.learnerIdOfTheSession = this.cancelrows[Index].bookinglearnerId;
                    this.usedCredit = this.cancelrows[Index].bookingcredits;
                    this.bookingIdForSession = this.cancelrows[Index].bookingid;
                    try {
                        if (!this.cancelrows[Index].isTrial) {
                            getFirebase.simpleGetDataFromSubCollectionWithDocID(
                            dbCollections.USERS,
                            this.learnerIdOfTheSession, 
                            async (resOFLearnerDetails)=>{
                                if(!resOFLearnerDetails){
                                    return;
                                }
                                await db.collection(dbCollections.CREDITTRANSACTIONS)
                                .where("userId","==",this.learnerIdOfTheSession)
                                .orderBy("createdAt", "desc")
                                .limit(1).get().then(async(docData) => {
                                    if(docData.empty){
                                    } else{
                                        let sengleBookingData = docData.docs[0].data();                                         
                                        const updateObj = {
                                            currentCredit : Number(resOFLearnerDetails.currentCredit) + Number(this.usedCredit)
                                        }
                                        await updateFirebase.updateRootCollectionDataByDocId(
                                        dbCollections.USERS,
                                        this.learnerIdOfTheSession,
                                        updateObj,async(res) => {
                                            if(!res){
                                                return;
                                            }
                                            const learnerDeatil = {
                                                firstName : resOFLearnerDetails.firstName ? resOFLearnerDetails.firstName :'',
                                                lastName : resOFLearnerDetails.lastName ? resOFLearnerDetails.lastName :'',
                                                profileImage: resOFLearnerDetails.profilePicture ? resOFLearnerDetails.profilePicture :''
                                            }
                                            const transactionObject = {
                                                availableCredit:Number(sengleBookingData.availableCredit) + Number(this.usedCredit),
                                                bookingId:this.bookingIdForSession,
                                                createdAt:new Date(),
                                                credits:Number(this.usedCredit),
                                                id:'',
                                                paymentId:'',// This feild is static
                                                reference:1,
                                                remarks:'Booking cancelled.',
                                                transactionType:"cr",
                                                userDetail:learnerDeatil,
                                                userId: this.learnerIdOfTheSession,
                                                isSendNotification: false
                                            }
                                            insertFirebase.addDataToRootCollection(
                                            dbCollections.CREDITTRANSACTIONS,
                                            transactionObject,async(credit) => {
                                                if(credit){
                                                    const updateObjCredit = {
                                                        id : credit.id
                                                    }
                                                    await updateFirebase.updateRootCollectionDataByDocId(
                                                    dbCollections.CREDITTRANSACTIONS,
                                                    credit.id,updateObjCredit,
                                                    async(creditUpdate) => {
                                                        const cancelreasondetail = {
                                                            cancellationReason: this.RadioSelected === "Other"? this.cancelReasonName :this.RadioSelected,
                                                            status: Number(3),
                                                            cancelReasonStatus: Number(0),
                                                            cancellationDate: new Date(),
                                                            updatedAt: new Date(),
                                                            usedCredits: 0
                                                        };
                                                        updateFirebase.updateRootCollectionDataByDocId(
                                                        dbCollections.BOOKING,
                                                        this.selctedSessionId,
                                                        cancelreasondetail,
                                                        async(res) => {
                                                            if(!res){
                                                                return;
                                                            }
                                                            adminBookingNotification({
                                                                bookingData : {...this.cancelrows[Index], status:3, cancellationReason: this.RadioSelected === "Other"? this.cancelReasonName :this.RadioSelected,}
                                                            }, () => {});
                                                            onBookingCancelUpdateSlot({
                                                                bookingId:  this.selctedSessionId
                                                            },() => {})
                                                            this.learnerIdOfTheSession = '';
                                                            this.usedCredit ='';
                                                            this.bookingIdForSession ='';
                                                            this.cancelrows.splice(Index, 1);
                                                            this.$bvModal.hide("modal-cancel-booking");
                                                            this.isSpinnerUp = false;
                                                            this.$root.$emit(
                                                                "showToastMessage",
                                                                "Booking cancel successfully.",
                                                                "success"
                                                            );
                                                        });
                                                    })
                                                } 
                                            })
                                        })  
                                    }
                                })
                                .catch((error) => {
                                    console.error(error);
                                })
                            });
                        }
                        else {
                            const cancelreasondetail = {
                                cancellationReason: this.RadioSelected === "Other"? this.cancelReasonName :this.RadioSelected,
                                status: Number(3),
                                cancelReasonStatus: Number(0),
                                cancellationDate: new Date(),
                                updatedAt: new Date(),
                                usedCredits: 0
                                };
                                updateFirebase.updateRootCollectionDataByDocId(
                                dbCollections.BOOKING,
                                this.selctedSessionId,
                                cancelreasondetail,
                                async(res) => {
                                    if(!res){
                                        return;
                                    }
                                    adminBookingNotification({
                                        bookingData : {...this.cancelrows[Index], status:3, cancellationReason: this.RadioSelected === "Other"? this.cancelReasonName :this.RadioSelected,}
                                    }, () => {});
                                    onBookingCancelUpdateSlot({
                                        bookingId:  this.selctedSessionId
                                    },() => {})
                                    this.learnerIdOfTheSession = '';
                                    this.usedCredit ='';
                                    this.bookingIdForSession ='';
                                    this.cancelrows.splice(Index, 1);
                                    this.$bvModal.hide("modal-cancel-booking");
                                    this.isSpinnerUp = false;
                                    this.$root.$emit(
                                        "showToastMessage",
                                        "Booking cancel successfully.",
                                        "success"
                                    );
                                });
                        }
                    } catch (error) {
                        console.error(error);
                        errorEmail({
                        projectName : process.env.VUE_APP_PROJECTNAME,
                        environment : process.env.NODE_ENV,
                        fileName : currentFileName,
                        hookName : "cancelbookinghandleSubmit",
                        errorMessage : error.message
                        },(res)=>{
                        if(res.error){
                            console.error(res.error)
                        }
                        })
                    }
                }
            })
        },

        onUpComingSessionLearner(){
            var self = this;
            var allTabList = document.getElementsByClassName('nav-link active')
            if (allTabList[0].innerText != 'Upcoming Session(s)') { 
                self.upcomingDetail();
            }
        }
    }
}
</script>
